import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownSelector, MultipleSelectorStateActions, } from '@dossierhq/design';
import { useEffect } from 'react';
export function TypeSelector({ schema, ...props }) {
    const { dispatch } = props;
    useEffect(() => {
        if (schema) {
            const items = [
                ...schema.spec.entityTypes.map((it) => ({ id: it.name, name: it.name, kind: 'entity' })),
                ...schema.spec.componentTypes.map((it) => ({ id: it.name, name: it.name, kind: 'component' })),
            ];
            dispatch(new MultipleSelectorStateActions.UpdateItems(items));
        }
    }, [schema, dispatch]);
    // useDebugLogChangedValues('TypeSelector changed values', { schema, dispatch });
    return _jsx(DropdownSelector, { ...props, renderItem: (item) => item.name });
}
//# sourceMappingURL=TypeSelector.js.map